import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalService } from './../services/global.service';
import { PipelineService } from './../services/pipeline-service';
import { Globals } from '../models/globals.model';
import { HttpClient } from '@angular/common/http';
import { FilterResponseModel } from '../models/filter/filter-response.model';
import { FilterModel } from '../models/filter/filter-request.model';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { FilterFieldTypes } from '../shared/common-constants';

@Component({
  selector: 'app-pipeline-configuration',
  templateUrl: './pipeline-configuration.component.html',
  styleUrls: ['./pipeline-configuration.component.css']
})
export class PipelineConfigurationComponent implements OnInit {

  isLoader: boolean = false;
  pipelineList;
  pipelineDetailLink;
  firstTableClass: string = "hideData";
  displayedColumns = ['name', 'description', 'folderName', 'Action'];
  @ViewChild('pipelineTableSort', { static: false }) public pipelineTableSort: MatSort;
  @ViewChild('pipelinePaginator', { static: true }) pipelinePaginator: MatPaginator;
  pipelineNameFilter = new UntypedFormControl('');
  FolderNameFilter = new UntypedFormControl('');
  pipelineDescriptionFilter = new UntypedFormControl('');

  filterValues = {
    name: '',
    description: '',
    folderName: ''
  };

  filterList: FilterModel[] = [];
  selectedFilters: FilterResponseModel[] = [];
  masterData: any;
  @ViewChild('popOver') public popover: NgbPopover;

  constructor(
    public globals: Globals,
    public globalService: GlobalService,
    public httpClient: HttpClient,
    public pipelineService: PipelineService,
    public router: Router,
    public _router: ActivatedRoute) { }

  ngOnInit() {
    this.getPipelineList();
    this.callADF();
    this.pipelineDescriptionFilter.valueChanges
      .subscribe(
        description => {
          this.filterValues.description = description;
          this.pipelineList.filter = JSON.stringify(this.filterValues);
        }
      )

    this.FolderNameFilter.valueChanges
      .subscribe(
        folderName => {
          this.filterValues.folderName = folderName;
          this.pipelineList.filter = JSON.stringify(this.filterValues);
        }
      )

    this.pipelineNameFilter.valueChanges
      .subscribe(
        name => {
          this.filterValues.name = name;
          this.pipelineList.filter = JSON.stringify(this.filterValues);
        }
      )
  }

  getPipelineList() {
    this.isLoader = true;
    this.pipelineService.fetchPipelines().subscribe((pipelines: any): void => {
      this.isLoader = false;
      let pipelineList = pipelines.sort((a, b) => {
        if(a.name == b.name){
          return 0;
        }
        return a.name > b.name ? 1 : -1
      })

      this.pipelineList = new MatTableDataSource(pipelineList);
      this.masterData = [...pipelineList];
      if (this.filterList.length == 0) {
        this.createFilterList();
      }
      this.pipelineList.sort = this.pipelineTableSort;
      this.pipelineList.paginator = this.pipelinePaginator;
      this.firstTableClass = "showData";
    });
    
  }

  callADF() {
    this.httpClient.get(this.globals.config.foundationPlatformApi_client_resourceUri + this.globalService.pipelineADFUrl).subscribe((data: any): void => {
      this.pipelineDetailLink = data;
    });
  }


  redirectToADF() {
    if (this.pipelineDetailLink.url != undefined) {
      window.open(this.pipelineDetailLink.url);
    }
  }

  /**Creates data for filter list */
  createFilterList() {
    for (let a = 0; a < this.displayedColumns.length-1; a++) {
      let tempFilter: FilterModel = new FilterModel();
      let unique;
      tempFilter.fieldType = FilterFieldTypes.text;
      tempFilter.fieldName = this.globalService.replaceDisplayText(this.displayedColumns[a]);
      if (this.displayedColumns[a] == "name") {
        unique = Array.from(new Set(this.pipelineList.data.map(a => a.name)));
      } else if (this.displayedColumns[a] == "description") {
        unique = Array.from(new Set(this.pipelineList.data.map(a => a.description)));
      } else if (this.displayedColumns[a] == "folderName") {
        unique = Array.from(new Set(this.pipelineList.data.map(a => a.folderName)));
      }
      tempFilter.values = unique;
      this.filterList.push(tempFilter);
    }
  }

  /**
  * Returns data from child filter component
  * @param event
  */
  filterResponse(event) {
    let filterRes: FilterResponseModel = event.filterResponse;
    this.pipelineList.data = this.globalService.conditionalDataFiltering(filterRes, this.pipelineList.data);
    this.selectedFilters.push(filterRes);
    if (this.popover.isOpen()) this.popover.close();
  }

  /**
   * Removes that filter
   * @param selectedFilter
   */
  remove(selectedFilter: FilterResponseModel): void {
    const i = this.selectedFilters.indexOf(selectedFilter);
    if (i >= 0) {
      this.selectedFilters.splice(i, 1);
      this.pipelineList.data = this.masterData.slice(0);
      if (this.selectedFilters.length > 0) {
        for (let ele of this.selectedFilters) {
          this.pipelineList.data = this.globalService.conditionalDataFiltering(ele, this.pipelineList.data);
        }
      }
    }
  }

}
